/* sections/truerim-cl-palette.liquid: section script (moved out of the section's javascript block 2026-10-22 so it loads only on pages that use
   the section). Loaded with defer by the section; runs once per page, like Shopify's compiled bundle did. */
/* ==== js:sections/truerim-cl-palette.liquid ==== */
(function () {
  var ran = window.__trRan = window.__trRan || {};
  if (ran['truerim-cl-palette']) return;
  ran['truerim-cl-palette'] = 1;
/* truerim-cl-palette: carousel -> tile selection, View all band, chips, search, select-then-navigate, spotlight swap,
   load more, phone dock (SPEC §5.4). The carousel itself (arch, keys, controls) is assets/tr-arc-carousel.js. */
(function boot() {
  if (!window.TRCL) { document.addEventListener('trcl:ready', boot, { once: true }); return; }
  var FAMS = [['white', 'White'], ['black', 'Black'], ['silver', 'Silver'], ['gray', 'Gray'], ['red', 'Red'], ['blue', 'Blue'],
    ['green', 'Green'], ['yellow', 'Yellow & gold'], ['orange', 'Orange'], ['brown', 'Brown & bronze'], ['purple', 'Purple'], ['pink', 'Pink']];
  var EASE = 'cubic-bezier(0,0,.58,1)';
  var slice = function (l) { return Array.prototype.slice.call(l || []); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  TRCL.section('[data-trcl-section="palette"]', function (root) {
    var doc = document;
    var server = root.getAttribute('data-trcl-grid-mode') === 'server', soffs = [];
    if (server) wireServer();
    var grid = root.querySelector('[data-trcl-grid]');
    if (!grid) return function () { soffs.forEach(function (f) { try { f(); } catch (e) {} }); };   /* empty (or filtered to nothing) */
    var sid = root.getAttribute('data-trcl-sid') || '';
    var tools = root.querySelector('[data-trcl-tools]');
    var chipsBox = root.querySelector('[data-trcl-chips]');
    var qInput = root.querySelector('[data-trcl-q]');
    var countEl = root.querySelector('[data-trcl-count]');
    var noneEl = root.querySelector('[data-trcl-none]');
    var statusEl = root.querySelector('[data-trcl-status]');
    var spot = root.querySelector('[data-trcl-spot]');
    var inner = root.querySelector('[data-trcl-spot-inner]');
    var dock = root.querySelector('[data-trcl-dock]');
    var arc = root.querySelector('[data-trcl-arc-wrap] [data-tr-arc]');
    var band = root.querySelector('[data-trcl-viewall]');
    var panel = root.querySelector('[data-trcl-all]');
    var total = parseInt(grid.getAttribute('data-trcl-total'), 10) || 0;
    var state = { fam: '', q: [] };
    var loading = null, allP = null, failed = false, offs = [], chipKey = '', moreIO = null, swapping = null;
    var animOK = !TRCL.still && typeof inner.animate === 'function';

    /* ---------- server mode (the catalogue): sort submits on change; the filter form moves into a modal <dialog>
       (bottom sheet / side panel) opened by the Filters buttons; the forms and chips are plain GET requests ---------- */
    function wireServer() {
      var sheet = root.querySelector('[data-trcl-fsheet]');
      var openers = slice(root.querySelectorAll('[data-trcl-fopen]'));
      var son = function (el, ev, fn) { el.addEventListener(ev, fn); soffs.push(function () { el.removeEventListener(ev, fn); }); };
      slice(root.querySelectorAll('[data-trcl-sort]')).forEach(function (f) {
        var go = f.querySelector('[data-trcl-sort-go]'), sel = f.querySelector('select');
        if (go) go.hidden = true;
        if (!sel) return;
        var kb = false;                                  /* keyboard: arrowing must not navigate (WCAG 3.2.2); the Sort button comes back */
        son(sel, 'keydown', function () { kb = true; if (go) go.hidden = false; });
        son(sel, 'pointerdown', function () { kb = false; });
        son(sel, 'change', function () { if (kb && go) return; if (f.requestSubmit) f.requestSubmit(); else f.submit(); });
      });
      if (!sheet) return;
      if (typeof window.HTMLDialogElement !== 'function') {   /* no <dialog>: the form stays inline, the buttons jump to it */
        openers.forEach(function (b) { b.hidden = false; son(b, 'click', function () { setAll(true); sheet.scrollIntoView({ block: 'start' }); }); });
        return;
      }
      var dlg = doc.createElement('dialog'), home = doc.createComment('trcl filters'), close = sheet.querySelector('[data-trcl-fclose]'), opener = null;
      dlg.className = 'trcl trcl-pal__fdlg';
      dlg.setAttribute('aria-labelledby', 'trcl-ftitle-' + (root.getAttribute('data-trcl-sid') || ''));
      dlg.setAttribute('data-trcl-fdlg', '');
      sheet.parentNode.insertBefore(home, sheet);
      dlg.appendChild(sheet);
      doc.body.appendChild(dlg);
      if (close) close.hidden = false;
      var shut = function () { if (dlg.open) dlg.close(); };
      son(dlg, 'close', function () { doc.documentElement.classList.remove('trcl-lock'); if (opener && opener.focus) opener.focus(); });
      son(dlg, 'click', function (e) { if (e.target === dlg) shut(); });   /* a tap on the backdrop */
      if (close) son(close, 'click', shut);
      openers.forEach(function (b) {
        b.hidden = false;
        son(b, 'click', function () {
          opener = b;
          setAll(true);
          try { dlg.showModal(); } catch (x) { dlg.setAttribute('open', ''); }
          doc.documentElement.classList.add('trcl-lock');
        });
      });
      soffs.push(function () {
        shut();
        if (home.parentNode) { home.parentNode.insertBefore(sheet, home); home.parentNode.removeChild(home); }
        if (dlg.parentNode) dlg.parentNode.removeChild(dlg);
      });
    }

    var on = function (el, ev, fn, opt) { el.addEventListener(ev, fn, opt); offs.push(function () { el.removeEventListener(ev, fn, opt); }); };
    var tiles = function () { return slice(grid.querySelectorAll('[data-trcl-tile]')); };
    var moreLink = function () { return root.querySelector('[data-trcl-more]'); };
    var hasMore = function () { return !failed && !!moreLink(); };
    var active = function () { return !!(state.fam || state.q.length); };
    var fams = function (li) { return (li.getAttribute('data-family') || '').split(/\s+/).filter(Boolean); };
    var matches = function (li) {
      if (state.fam && fams(li).indexOf(state.fam) < 0) return false;
      var s = li.getAttribute('data-search') || '';
      for (var i = 0; i < state.q.length; i++) if (s.indexOf(state.q[i]) < 0) return false;
      return true;
    };
    var detailOf = function (li) {
      var a = function (k) { return li.getAttribute('data-' + k) || ''; };
      return { name: a('name'), url: a('url'), hex: a('hex') || '#cccccc', finish: a('finish'), code: a('code'), price: a('price'),
               sizes: a('sizes'), make: a('make'), premixed: a('premixed') === 'true' };
    };
    var finishLc = function (f) { return String(f || '').toLowerCase().replace(/,/g, ' ').replace(/\s+/g, ' ').trim(); };

    /* ---------- count, empty state, filtering ---------- */
    function setCount(shown, busy) {
      if (!countEl) return;
      var of = Math.max(total, tiles().length);
      countEl.textContent = busy ? 'Searching all ' + of + ' colors…' : 'Showing ' + shown + ' of ' + of;
    }
    function apply(replay) {
      var list = tiles(), shown = [], changed = false;
      list.forEach(function (li) {
        var ok = matches(li);
        if (li.hidden === ok) { li.hidden = !ok; changed = true; }
        if (ok) shown.push(li);
      });
      var busy = active() && hasMore() && !!(loading || allP);
      setCount(shown.length, busy);
      /* a search down to one color (a typed paint code, 2026-10-13): show it in the spotlight right away */
      if (state.q.length && shown.length === 1 && !busy && !shown[0].querySelector('.trcl-tile.is-on')) select(shown[0]);
      if (noneEl) noneEl.hidden = shown.length > 0 || busy;
      if (replay && changed) {
        shown.forEach(function (li, i) {
          li.style.setProperty('--trcl-y', '20px');
          li.style.setProperty('--trcl-dur', '.5s');
          li.style.setProperty('--trcl-e', EASE);
          TRCL.replay(li, Math.min(i, 12) * 0.04);
        });
      }
    }
    function buildChips() {
      if (!chipsBox) return;
      var counts = {}, list = tiles();
      list.forEach(function (li) { fams(li).forEach(function (f) { counts[f] = (counts[f] || 0) + 1; }); });
      var present = FAMS.filter(function (f) { return counts[f[0]]; });
      if (present.length < 2 && !state.fam) { chipsBox.hidden = true; chipsBox.innerHTML = ''; chipKey = ''; return; }
      chipsBox.hidden = false;
      var all = Math.max(total, list.length);
      var key = present.map(function (f) { return f[0]; }).join(',');
      if (key === chipKey) {                             /* same chips: update counts in place (keeps focus) */
        slice(chipsBox.querySelectorAll('[data-fam]')).forEach(function (b) {
          var f = b.getAttribute('data-fam'), sm = b.querySelector('small');
          if (sm) sm.textContent = f ? (counts[f] || 0) : all;
        });
        return;
      }
      var focused = doc.activeElement && chipsBox.contains(doc.activeElement) ? doc.activeElement.getAttribute('data-fam') : null;
      chipKey = key;
      var html = '<button type="button" class="trcl-chip" data-fam="" aria-pressed="' + (!state.fam) + '">All <small>' + all + '</small></button>';
      present.forEach(function (f) {
        html += '<button type="button" class="trcl-chip" data-fam="' + f[0] + '" aria-pressed="' + (state.fam === f[0]) + '">' +
          esc(f[1]) + ' <small>' + counts[f[0]] + '</small></button>';
      });
      chipsBox.innerHTML = html;
      if (focused !== null) { var fb = chipsBox.querySelector('[data-fam="' + focused + '"]'); if (fb) fb.focus(); }
    }
    function filterChanged() {
      apply(true);
      if (active() && hasMore()) loadAll().then(function () { apply(true); });
    }

    /* ---------- load more (Section Rendering API: next.url + section_id) ---------- */
    function sectionUrl(href) {
      try { var u = new URL(href, location.href); if (sid) u.searchParams.set('section_id', sid); return u.toString(); }
      catch (e) { return href; }
    }
    function loadNext() {
      if (loading) return loading;
      var a = moreLink();
      if (!a || failed || !window.fetch || !window.DOMParser) return Promise.resolve(false);
      var label = a.textContent, href = a.getAttribute('href');
      a.classList.add('is-loading'); a.setAttribute('aria-busy', 'true'); a.textContent = 'Loading colors…';
      loading = fetch(sectionUrl(href), { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      }).then(function (html) {
        var d = new DOMParser().parseFromString(html, 'text/html');
        var scope = d.querySelector('[data-trcl-section="palette"][data-trcl-sid="' + sid + '"]') || d.querySelector('[data-trcl-section="palette"]') || d;
        var have = {}, added = 0;
        tiles().forEach(function (li) { have[li.getAttribute('data-url')] = 1; });
        slice(scope.querySelectorAll('[data-trcl-grid] [data-trcl-tile]')).forEach(function (li) {
          var u = li.getAttribute('data-url');
          if (!u || have[u]) return;
          have[u] = 1;
          var t = li.querySelector('.trcl-tile');
          if (t) { t.classList.remove('is-on'); t.removeAttribute('aria-current'); }
          li.hidden = !matches(li);
          grid.appendChild(doc.importNode(li, true));
          added++;
        });
        var next = scope.querySelector('[data-trcl-more]');
        var nextHref = next && next.getAttribute('href');
        a.classList.remove('is-loading'); a.removeAttribute('aria-busy'); a.textContent = label;
        if (nextHref && nextHref !== href && added) { a.setAttribute('href', nextHref); }
        else if (nextHref && !added) { failed = true; }          /* no progress: stop auto-loading, the link navigates */
        else { removeMore(a); }
        buildChips();
        TRCL.scan(grid.parentNode);                      /* scan() looks at descendants: pass the grid's parent */
        return !!nextHref && !failed;
      }).catch(function (err) {
        failed = true;
        a.classList.remove('is-loading'); a.removeAttribute('aria-busy'); a.textContent = label;
        if (window.console) console.warn('[trcl palette] load more failed; the link still works', err);
        return false;
      }).then(function (more) {
        loading = null;
        apply(false);
        if (more && moreIO) { var m = moreLink(); if (m) { moreIO.unobserve(m); moreIO.observe(m); } }
        return more;
      });
      return loading;
    }
    function removeMore(a) {
      if (moreIO) moreIO.unobserve(a);
      var nav = a.parentNode;
      a.parentNode.removeChild(a);
      if (nav && !nav.querySelector('a')) nav.parentNode.removeChild(nav);
    }
    function loadAll() {
      if (allP) return allP;
      var step = function () { return loadNext().then(function (more) { return more && hasMore() ? step() : null; }); };
      allP = step().then(function () { allP = null; apply(false); });
      return allP;
    }

    /* ---------- spotlight swap (out y-20 / in from y20, .4s each, sequential) ---------- */
    function fill(d) {
      var q = function (s) { return inner.querySelector(s); };
      var sw = q('[data-trcl-s-sw]'), fin = q('[data-trcl-s-finish]'), nm = q('[data-trcl-s-name]'), code = q('[data-trcl-s-code]');
      var sz = q('[data-trcl-s-sizes]'), pr = q('[data-trcl-s-price]'), ln = q('[data-trcl-s-link]');
      if (sw) {
        sw.style.setProperty('--sw', d.hex);
        var fl = finishLc(d.finish);
        if (fl) sw.setAttribute('data-finish', fl); else sw.removeAttribute('data-finish');
        sw.setAttribute('aria-label', d.name + ' color swatch');
      }
      if (fin) { fin.textContent = d.finish; fin.hidden = !d.finish; }
      if (nm) nm.textContent = d.name;
      if (code) { var c = d.code && !d.premixed ? 'Paint code ' + d.code : ''; code.textContent = c; code.hidden = !c; }
      if (sz) { sz.textContent = d.sizes; sz.hidden = !d.sizes; }
      if (pr) pr.textContent = d.price;
      if (ln) ln.setAttribute('href', d.url);
    }
    var pending = null;
    function swap(d) {
      pending = d;
      if (!animOK) { fill(d); return; }
      if (swapping === 'out') return;                    /* the running exit fills the latest pick when it ends */
      if (swapping && swapping.cancel) swapping.cancel();
      var out;
      try {
        out = inner.animate([{ opacity: 1, transform: 'translateY(0)' }, { opacity: 0, transform: 'translateY(-20px)' }],
          { duration: 400, easing: EASE, fill: 'forwards' });
      } catch (e) { animOK = false; fill(d); return; }
      swapping = 'out';
      var ended = false;
      var next = function () {                           /* onfinish, or the timer if the animation timeline is paused */
        if (ended) return;
        ended = true;
        fill(pending);
        out.cancel();
        var inn = inner.animate([{ opacity: 0, transform: 'translateY(20px)' }, { opacity: 1, transform: 'translateY(0)' }],
          { duration: 400, easing: EASE });
        swapping = inn;
        inn.onfinish = function () { if (swapping === inn) swapping = null; };
        setTimeout(function () { if (swapping === inn) { inn.cancel(); swapping = null; } }, 900);
      };
      out.onfinish = next;
      setTimeout(next, 500);
    }

    /* ---------- phone dock ---------- */
    var mqDesk = window.matchMedia ? window.matchMedia('(min-width: 1024px)') : { matches: false };
    var palIn = false, spotIn = false, arcIn = false, dockT = null;
    var picked = !server;                                /* server mode: no carousel, so the dock waits for a real tile pick */
    function dockFill(d) {
      if (!dock) return;
      var sw = dock.querySelector('[data-trcl-d-sw]'), nm = dock.querySelector('[data-trcl-d-name]');
      var pr = dock.querySelector('[data-trcl-d-price]'), ln = dock.querySelector('[data-trcl-d-link]');
      if (sw) sw.style.setProperty('--sw', d.hex);
      if (nm) nm.textContent = d.name;
      if (pr) pr.textContent = d.price;
      if (ln) { ln.setAttribute('href', d.url); ln.setAttribute('aria-label', 'Build kit: ' + d.name); }
    }
    function dockUpdate() {
      if (!dock) return;
      var show = palIn && !spotIn && !arcIn && !mqDesk.matches && picked && !(server && panel && panel.hidden);
      clearTimeout(dockT);
      if (show) {
        if (dock.hidden) { dock.hidden = false; void dock.offsetWidth; }
        dock.classList.add('is-in');
      } else if (!dock.hidden) {
        dock.classList.remove('is-in');
        dockT = setTimeout(function () { dock.hidden = true; }, TRCL.still ? 0 : 450);
      }
    }
    if (dock && 'IntersectionObserver' in window) {
      doc.body.appendChild(dock);
      offs.push(function () { if (dock.parentNode) dock.parentNode.removeChild(dock); });
      var dio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.target === root) palIn = en.isIntersecting;
          else if (en.target === arc) arcIn = en.isIntersecting && en.intersectionRatio >= 0.25;
          else spotIn = en.isIntersecting && en.intersectionRatio >= 0.25;
        });
        dockUpdate();
      }, { threshold: [0, 0.25, 0.5] });
      dio.observe(root);
      if (spot) dio.observe(spot);
      if (arc) dio.observe(arc);                         /* the carousel shows the selected color too */
      offs.push(function () { dio.disconnect(); });
      if (mqDesk.addEventListener) { mqDesk.addEventListener('change', dockUpdate); offs.push(function () { mqDesk.removeEventListener('change', dockUpdate); }); }
    }

    /* ---------- selection: first tap selects, a second tap on the selected tile follows the link ---------- */
    function select(li, fromArc, quiet) {
      var a = li.querySelector('.trcl-tile');
      slice(grid.querySelectorAll('.trcl-tile.is-on')).forEach(function (t) { t.classList.remove('is-on'); t.removeAttribute('aria-current'); });
      if (a) { a.classList.add('is-on'); a.setAttribute('aria-current', 'true'); }
      var d = detailOf(li);
      if (quiet) { pending = d; fill(d); } else swap(d);   /* boot pick: no swap animation */
      if (!quiet) picked = true;
      dockFill(d);
      dockUpdate();
      if (statusEl && !quiet) statusEl.textContent = d.name + ' selected. Select it again to open its page.';
      TRCL.emit('color', d);
      if (!fromArc) arcTo(d.url);
    }
    on(grid, 'click', function (e) {
      var a = e.target.closest ? e.target.closest('a.trcl-tile') : null;
      if (!a || !grid.contains(a) || e.defaultPrevented) return;
      if (e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;   /* new tab / window: let the browser go */
      if (a.classList.contains('is-on')) return;                                  /* second click: navigate */
      e.preventDefault();
      select(a.closest('[data-trcl-tile]'));
    });

    /* ---------- carousel: the centred card selects its tile once the row settles; side card tap = centre it ---------- */
    var cards = function () { return arc ? slice(arc.querySelectorAll('[data-trcl-arc-card]')) : []; };
    var tileFor = function (url) { var t = tiles().filter(function (li) { return li.getAttribute('data-url') === url; }); return t[0] || null; };
    var armed = false, arcT = null;                      /* only shopper-driven moves select (not the row's own boot) */
    function arcTo(url) {
      if (!arc || !window.TRArc) return;
      var i = cards().map(function (c) { return c.getAttribute('data-url'); }).indexOf(url);
      if (i > -1) TRArc.go(arc, i);
    }
    if (arc) {
      var arm = function () { armed = true; };
      ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (ev) { on(arc, ev, arm, { passive: true }); });
      on(arc, 'tr-arc:change', function (e) {
        clearTimeout(arcT);
        var it = e.detail && e.detail.item;
        if (!armed || !it) return;
        arcT = setTimeout(function () {
          var li = tileFor(it.getAttribute('data-url'));
          if (li && !li.querySelector('.trcl-tile.is-on')) select(li, true);
        }, 260);
      });
      offs.push(function () { clearTimeout(arcT); });
      /* the row opens on data-tr-arc-start: select that color now (quietly) so the tiles, spotlight and kit match it */
      /* (next task: the kit card's listener registers after this section's boot) */
      var c0 = cards()[parseInt(arc.getAttribute('data-tr-arc-start'), 10) || 0], t0 = c0 && tileFor(c0.getAttribute('data-url'));
      var bootT = setTimeout(function () { if (t0 && !t0.querySelector('.trcl-tile.is-on')) select(t0, true, true); }, 0);
      offs.push(function () { clearTimeout(bootT); });
      on(arc, 'click', function (e) {
        var a = e.target.closest ? e.target.closest('a.trcl-pal__card') : null;
        if (!a || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        var card = a.closest('[data-trcl-arc-card]');
        if (!card || (window.TRArc && TRArc.tapOpens ? TRArc.tapOpens(card) : card.classList.contains('is-center')) || !window.TRArc) return;   /* centre card: open the product */
        e.preventDefault();
        armed = true;
        TRArc.go(arc, cards().indexOf(card));
      });
    }

    /* ---------- "View all" band: collapses the grid panel behind a button (only when the carousel is there) ---------- */
    function setAll(open) {
      if (!band || !panel || !band.hasAttribute('data-trcl-on')) return;
      panel.hidden = !open;
      band.setAttribute('aria-expanded', String(open));
      var lb = band.querySelector('[data-trcl-viewall-label]');
      if (lb) lb.textContent = lb.getAttribute(open ? 'data-trcl-on' : 'data-trcl-off');
      var bf = server && root.querySelector('.trcl-pal__bandf');   /* the grid's own Filters button takes over once it is open */
      if (bf) bf.hidden = open;
      dockUpdate();
    }
    /* links that need the grid open first (2026-10-13 friction pass): #trcl-find (the hero's "Find your paint code" on
       make and aerosol pages: grid + search, focused), and any link marked data-trcl-grid-open whose target is in this
       section (the catalogue's "All colors · Filter" chip, the finder's "Filter all colors"). Capture phase: the grid is
       open before trcl-base measures the jump. */
    var gridLink = function (e) {
      var a = e.target.closest ? e.target.closest('a[href]') : null;
      if (!a || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var id = (a.getAttribute('href') || '').split('#')[1], tg = id && doc.getElementById(id);
      if (!tg || !root.contains(tg) || !(id === 'trcl-find' || a.hasAttribute('data-trcl-grid-open'))) return;
      if (band && band.hasAttribute('data-trcl-on') && panel && panel.hidden) setAll(true);
      if (id === 'trcl-find' && qInput && !a.hasAttribute('data-trcl-scroll')) setTimeout(function () { try { qInput.focus({ preventScroll: true }); } catch (x) { qInput.focus(); } }, 0);
    };
    doc.addEventListener('click', gridLink, true);
    offs.push(function () { doc.removeEventListener('click', gridLink, true); });
    if (band && panel && (arc || server)) {
      band.setAttribute('data-trcl-on', '');
      band.hidden = false;
      setAll(panel.hasAttribute('data-trcl-open'));
      if (server && !panel.hidden && !location.hash && (window.pageYOffset || 0) < 10) {   /* outside filter / page link: land on the grid once */
        var gAnchor = doc.getElementById('trcl-catalogue-grid');
        if (gAnchor) setTimeout(function () { gAnchor.scrollIntoView({ block: 'start' }); }, 0);
      }
      on(band, 'click', function () { setAll(panel.hidden); });
      offs.push(function () { panel.hidden = false; band.hidden = true; });
      if (location.hash === '#trcl-find' && panel.hidden) {
        setAll(true);
        var fa = doc.getElementById('trcl-find');
        if (fa) setTimeout(function () { TRCL.scrollTo(fa); if (qInput) { try { qInput.focus({ preventScroll: true }); } catch (x) {} } }, 0);
      }
    }

    /* ---------- tools ---------- */
    if (tools) tools.hidden = false;
    buildChips();
    if (chipsBox) on(chipsBox, 'click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-fam]') : null;
      if (!b) return;
      state.fam = b.getAttribute('data-fam') || '';
      slice(chipsBox.querySelectorAll('[data-fam]')).forEach(function (c) { c.setAttribute('aria-pressed', String(c === b)); });
      filterChanged();
    });
    if (qInput) {
      var qt = null;
      on(qInput, 'input', function () {
        clearTimeout(qt);
        qt = setTimeout(function () {
          state.q = qInput.value.toLowerCase().trim().split(/\s+/).filter(Boolean);
          filterChanged();
        }, 140);
      });
      on(qInput, 'keydown', function (e) {
        if (e.key !== 'Enter') return;
        e.preventDefault();
        /* Enter with exactly one matching color opens it (2026-10-13) */
        clearTimeout(qt); state.q = qInput.value.toLowerCase().trim().split(/\s+/).filter(Boolean); apply(false);
        var one = state.q.length ? tiles().filter(function (li) { return !li.hidden; }) : [];
        if (one.length === 1 && one[0].getAttribute('data-url')) window.location.assign(one[0].getAttribute('data-url'));
      });
    }
    /* first touch of the tools: fetch the remaining pages in the background so chip counts and results cover them */
    if (tools) {
      var warm = function () { if (hasMore()) loadAll(); };
      on(tools, 'focusin', warm, { once: true });
      on(tools, 'pointerdown', warm, { once: true });
    }
    var reset = root.querySelector('[data-trcl-reset]');
    if (reset) on(reset, 'click', function () {
      state.fam = ''; state.q = [];
      if (qInput) qInput.value = '';
      if (chipsBox) slice(chipsBox.querySelectorAll('[data-fam]')).forEach(function (c) { c.setAttribute('aria-pressed', String(!c.getAttribute('data-fam'))); });
      apply(true);
      if (qInput) qInput.focus();
    });

    /* ---------- "Show more colors": click loads in place; auto-loads within 400px of the viewport ---------- */
    on(root, 'click', function (e) {
      var a = e.target.closest ? e.target.closest('[data-trcl-more]') : null;
      if (!a || failed || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      loadNext();
    });
    var m0 = moreLink();
    if (m0 && 'IntersectionObserver' in window) {
      moreIO = new IntersectionObserver(function (entries) {
        if (entries.some(function (en) { return en.isIntersecting; }) && !failed) loadNext();
      }, { rootMargin: '400px 0px 400px 0px' });
      moreIO.observe(m0);
      offs.push(function () { moreIO.disconnect(); });
    }

    apply(false);
    return function () { offs.concat(soffs).forEach(function (f) { try { f(); } catch (e) {} }); };
  });
})();
})();
/* ==== end js:sections/truerim-cl-palette.liquid ==== */
